/* eslint-disable prettier/prettier */
/* eslint-disable react/require-default-props */
import React from 'react';
import './styles.css';

interface hyperlinkProps {
  onClick?: () => void;
  className?: string;
  text?: string;
  children?: any;
}

export default function HyperLink({ onClick, className, text, children, ...props }: hyperlinkProps) {
  return (
    <div className="hyperlink-children">
      <div onClick={onClick} className={className ?? 'hyperlink-with-underline'}>
        <p>{text}</p>
        {children}
      </div>
    </div>
  );
}
